import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  InputAdornment,
  TextField,
  Divider,
} from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
// import VehicleCategoryService from "src/service/vehicleCategory";
import ReportService from "src/service/reports";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";

import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Device Stock",
  },
];

const DeviceStockReport = () => {
  // ====================================

  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [deviceStock, setDeviceStock] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);

  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("imei_no"); // Initial column to sort

  const fetchDeviceStocks = async () => {
    try {
      const res = await ReportService.getDeviceStocksReports({});

      setDeviceStock(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteVehicleCategory = async (id) => {
    swal({
      title: "Delete device Stock",
      text: "Are you sure you want to delete this device Stock?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await ReportService.deleteVehicleCategory({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetchDeviceStocks();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetchDeviceStocks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const filteredVehicle = deviceStock.filter(
    (man) =>
      man.man_u_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.imei_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.device_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.dist_u_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.batch_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.device_serial_no.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = deviceStock.filter(
      (man) =>
        man.man_u_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        man.imei_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
        man.device_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        man.dist_u_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        man.batch_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
        man.device_serial_no.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [deviceStock, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "Dsitributer Name",
      "Dsitributer ID",
      "Manufature ID",
      "Imei No.",
      "Device Name",
      "Serial No.",
      "Batch No.",
      "Model",
      "Device Qty (IN)",
      "Device Qty (OUT)",
      "Balance Qty",
      "Device Rate(₹/P)",
      "GST(%)",
      "Total Amount(₹)",
    ];

    const data = visibleData.map((man, index) => [
      index + 1,
      man.distributor_name,
      man.dist_u_id,
      man.man_u_id,
      man.imei_no,
      man.device_name,
      man.device_serial_no,
      man.batch_no,
      man.model_id,
      man.in_device_quantity,
      man.out_device_quantity,
      man.balance_quantity,
      man.device_rate,
      man.gst,
      man.total_amount,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "deviceStock_data.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  const sortedStocks = filteredVehicle.sort((a, b) => {
    const compareValueA = a[sortColumn];
    const compareValueB = b[sortColumn];

    // Customize the comparison based on data types or specific conditions
    if (sortOrder === "asc") {
      return compareValueA.localeCompare(compareValueB);
    } else {
      return compareValueB.localeCompare(compareValueA);
    }
  });

  // ====================================
  return (
    <PageContainer title="Device Stock" description="this is Basic Table page">
      {/* breadcrumb */}
      <Breadcrumb title="Device Stock" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Device Stocks
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            {sessionData.data.user_type === 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/addVehicle");
                }}
              >
                <IconPlus width={20} />
              </Button>
            )}
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "20px;",
              marginTop: "20px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder="Search here "
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell style={{ textAlign: "center" }}>
                    <Typography style={{ fontSize: "14px" }} variant="h6">
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Dsitributer Name
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Dsitributer ID
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Manufature ID
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Imei No.
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Name
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Serial No.
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Batch No.
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Model
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Qty (IN)
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Qty (OUT)
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Balance Qty
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Rate(₹/P)
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      GST(%)
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("man_u_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Total Amount(₹)
                      {sortColumn === "man_u_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  {sessionData.data.user_type === 1 && (
                    <TableCell style={{ textAlign: "center" }}>
                      <Typography style={{ fontSize: "13px" }} variant="h6">
                        Action
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedStocks.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedStocks
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {index + 1}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.distributor_name}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.dist_u_id}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.man_u_id}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.imei_no}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.device_name}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.device_serial_no}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.batch_no}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.model_id}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.in_device_quantity}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.out_device_quantity !== null
                              ? man.out_device_quantity
                              : "0"}
                            {/* {man.out_device_quantity} */}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.balance_quantity}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.device_rate + ".00"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.gst} %
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "12px" }} variant="h6">
                            {man.total_amount + ".00"}
                          </Typography>
                        </TableCell>
                        {sessionData.data.user_type === 1 && (
                          <TableCell style={{ textAlign: "center" }}>
                            <Link to={`/updateVehicle/${man.id}`}>
                              <ModeEditOutlinedIcon
                                style={{
                                  color: "blue",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>

                            <DeleteOutlinedIcon
                              style={{
                                color: "red",
                                fontSize: "18px",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => deleteVehicleCategory(man.id)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={sortedStocks.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default DeviceStockReport;
